import { GrowthRateBasisType, Nullable, ReferenceData } from '@xplan-pension-switching/common';
import { formatPercentageTwoDecimalPlaces } from '../../helpers';

export const useIndustryStandardRows = (
    {
        industryStandardGrowthRatePercentageLow,
        industryStandardGrowthRatePercentageMid,
        industryStandardGrowthRatePercentageHigh,
        inflationAdjustedGrowthRatePercentageLow,
        inflationAdjustedGrowthRatePercentageMid,
        inflationAdjustedGrowthRatePercentageHigh,
    }: ReferenceData,
    selectedGrowthRateBasisType: GrowthRateBasisType
): Nullable<
    Array<{
        growthRate: string;
        nominalRate: string;
        inflationAdjustedRate: string;
    }>
> =>
    selectedGrowthRateBasisType === GrowthRateBasisType.IndustryStandard
        ? [
              {
                  growthRate: 'Low',
                  nominalRate: formatPercentageTwoDecimalPlaces(industryStandardGrowthRatePercentageLow),
                  inflationAdjustedRate: formatPercentageTwoDecimalPlaces(inflationAdjustedGrowthRatePercentageLow),
              },
              {
                  growthRate: 'Mid',
                  nominalRate: formatPercentageTwoDecimalPlaces(industryStandardGrowthRatePercentageMid),
                  inflationAdjustedRate: formatPercentageTwoDecimalPlaces(inflationAdjustedGrowthRatePercentageMid),
              },
              {
                  growthRate: 'High',
                  nominalRate: formatPercentageTwoDecimalPlaces(industryStandardGrowthRatePercentageHigh),
                  inflationAdjustedRate: formatPercentageTwoDecimalPlaces(inflationAdjustedGrowthRatePercentageHigh),
              },
          ]
        : null;
